'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2; /* eslint-disable */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _components = require('components');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * SearchUsers, panel which admin has access to upon
 * login, this panel enables the admin to obtain
 * important information about all users using Reboot
 * Kids
 * https://github.com/react-tools/react-table
 */
var AdminModules = (_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user, moduleApp: state.adminModuleApps.modules };
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(AdminModules, _Component);

  function AdminModules() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, AdminModules);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AdminModules.__proto__ || (0, _getPrototypeOf2.default)(AdminModules)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      title: 'Modules',
      selected: '0.1', // the selected key
      modules: [{
        // module name
        title: 'Getting Ready',
        apps: [{
          id: 1,
          appName: 'Introduction',
          prop: _this.props.moduleApp.module0app1
        }, {
          id: 2,
          appName: 'Food pyramid',
          prop: _this.props.moduleApp.module0app2
        }, {
          id: 3,
          appName: 'Importance of healthy eating',
          prop: _this.props.moduleApp.module0app3
        }, {
          id: 4,
          appName: 'Your goals',
          prop: _this.props.moduleApp.module0app4
        }, {
          id: 5,
          appName: 'Barriers',
          prop: _this.props.moduleApp.module0app5
        }]
      }, {
        // module name
        title: 'Healthy eating habits',
        apps: [{
          id: 1,
          appName: 'Health eating habits',
          prop: _this.props.moduleApp.module1app1
        }, {
          id: 2,
          appName: 'Healthy eating pyramid',
          prop: _this.props.moduleApp.module1app2
        }, {
          id: 3,
          appName: 'What is a serve?',
          prop: _this.props.moduleApp.module1app3
        }, {
          id: 4,
          appName: 'Is your child getting the recommended number of serves?',
          prop: _this.props.moduleApp.module1app4
        }, {
          id: 5,
          appName: 'Is your child getting their recommended serve?',
          prop: _this.props.moduleApp.module1app5
        }, {
          id: 6,
          appName: 'General serve guide',
          prop: _this.props.moduleApp.module1app6
        }, {
          id: 7,
          appName: 'Recommended serve for others',
          prop: _this.props.moduleApp.module1app7
        }, {
          id: 8,
          appName: 'What is a non-core food?',
          prop: _this.props.moduleApp.module1app8
        }, {
          id: 9,
          appName: 'Intro to Reboot Kid Activities',
          prop: _this.props.moduleApp.module1app9
        }, {
          id: 10,
          appName: 'Goal setting',
          prop: _this.props.moduleApp.module1app10
        }]
      }, {
        // module name
        title: 'Home food environment',
        apps: [{
          id: 1,
          appName: 'Recap',
          prop: _this.props.moduleApp.module2app1
        }, {
          id: 2,
          appName: 'Making changes',
          prop: _this.props.moduleApp.module2app2
        }, {
          id: 3,
          appName: 'Eating HELPS guide',
          prop: _this.props.moduleApp.module2app3
        }, {
          id: 4,
          appName: 'Home food environment',
          prop: _this.props.moduleApp.module2app4
        }, {
          id: 5,
          appName: 'Accessibility',
          prop: _this.props.moduleApp.module2app5
        }, {
          id: 6,
          appName: 'Meal planning',
          prop: _this.props.moduleApp.module2app6
        }, {
          id: 7,
          appName: 'Cost saving tips',
          prop: _this.props.moduleApp.module2app7
        }, {
          id: 8,
          appName: 'Program goals',
          prop: _this.props.moduleApp.module2app8
        }, {
          id: 9,
          appName: 'Strategies',
          prop: _this.props.moduleApp.module2app9
        }]
      }, {
        // module name
        title: 'Encouraging vegetables',
        apps: [{
          id: 1,
          appName: 'Recap',
          prop: _this.props.moduleApp.module3app1
        }, {
          id: 2,
          appName: 'Overview',
          prop: _this.props.moduleApp.module3app2
        }, {
          id: 3,
          appName: 'The P\'s and C\'s',
          prop: _this.props.moduleApp.module3app3
        }, {
          id: 4,
          appName: 'Feeding Part 1',
          prop: _this.props.moduleApp.module3app4
        }, {
          id: 5,
          appName: 'Feeding Part 2',
          prop: _this.props.moduleApp.module3app5
        }, {
          id: 6,
          appName: 'Meal Preparation',
          prop: _this.props.moduleApp.module3app6
        }, {
          id: 7,
          appName: 'What to avoid',
          prop: _this.props.moduleApp.module3app7
        }, {
          id: 8,
          appName: 'Strategies',
          prop: _this.props.moduleApp.module3app8
        }]
      }, {
        // module name
        title: 'Review and future planning',
        apps: [{
          id: 1,
          appName: 'Recap',
          prop: _this.props.moduleApp.module4app1
        }, {
          id: 2,
          appName: 'Overview',
          prop: _this.props.moduleApp.module4app2
        }, {
          id: 3,
          appName: 'Barriers',
          prop: _this.props.moduleApp.module4app3
        }, {
          id: 4,
          appName: 'Getting support',
          prop: _this.props.moduleApp.module4app4
        }, {
          id: 5,
          appName: 'Review',
          prop: _this.props.moduleApp.module4app5
        }, {
          id: 6,
          appName: 'Consistency',
          prop: _this.props.moduleApp.module4app6
        }, {
          id: 7,
          appName: 'Difficult situations',
          prop: _this.props.moduleApp.module4app7
        }, {
          id: 8,
          appName: 'Goals',
          prop: _this.props.moduleApp.module4app8
        }, {
          id: 9,
          appName: 'Completion',
          prop: _this.props.moduleApp.module4app9
        }, {
          id: 10,
          appName: 'Strategies',
          prop: _this.props.moduleApp.module4app10
        }]
      }, {
        title: 'Booster module',
        apps: [{
          id: 1,
          appName: 'Booster',
          prop: _this.props.moduleApp.module5app1
        }, {
          id: 2,
          appName: 'Summary',
          prop: _this.props.moduleApp.module5app2
        }, {
          id: 3,
          appName: 'Review',
          prop: _this.props.moduleApp.module5app3
        }]
      }]
    }, _this.handleSelect = function (eventValue) {
      var obj = _this.state;
      obj.selected = eventValue;
      _this.setState(obj);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(AdminModules, [{
    key: 'render',
    value: function render() {
      var styles = require('./Admin.scss');
      var selected = this.state.selected;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          ReactBootstrap.Row,
          null,
          _react2.default.createElement(
            ReactBootstrap.Col,
            { md: 12 },
            _react2.default.createElement(
              'h1',
              null,
              this.state.title
            ),
            _react2.default.createElement(
              ReactBootstrap.Nav,
              { bsStyle: 'pills', activeKey: selected, onSelect: this.handleSelect.bind(this) },
              _react2.default.createElement(
                ReactBootstrap.NavDropdown,
                { eventKey: '0', title: this.state.modules[0].title, id: 'nav-dropdown' },
                this.state.modules[0].apps.map(function (item, index) {
                  return _react2.default.createElement(
                    ReactBootstrap.MenuItem,
                    { eventKey: '0.' + (index + 1) },
                    'App ',
                    item.id,
                    ' - ',
                    item.appName
                  );
                })
              ),
              _react2.default.createElement(
                ReactBootstrap.NavDropdown,
                { eventKey: '1', title: this.state.modules[1].title, id: 'nav-dropdown' },
                this.state.modules[1].apps.map(function (item, index) {
                  return _react2.default.createElement(
                    ReactBootstrap.MenuItem,
                    { eventKey: '1.' + (index + 1) },
                    'App ',
                    item.id,
                    ' - ',
                    item.appName
                  );
                })
              ),
              _react2.default.createElement(
                ReactBootstrap.NavDropdown,
                { eventKey: '2', title: this.state.modules[2].title, id: 'nav-dropdown' },
                this.state.modules[2].apps.map(function (item, index) {
                  return _react2.default.createElement(
                    ReactBootstrap.MenuItem,
                    { eventKey: '2.' + (index + 1) },
                    'App ',
                    item.id,
                    ' - ',
                    item.appName
                  );
                })
              ),
              _react2.default.createElement(
                ReactBootstrap.NavDropdown,
                { eventKey: '3', title: this.state.modules[3].title, id: 'nav-dropdown' },
                this.state.modules[3].apps.map(function (item, index) {
                  return _react2.default.createElement(
                    ReactBootstrap.MenuItem,
                    { eventKey: '3.' + (index + 1) },
                    'App ',
                    item.id,
                    ' - ',
                    item.appName
                  );
                })
              ),
              _react2.default.createElement(
                ReactBootstrap.NavDropdown,
                { eventKey: '4', title: this.state.modules[4].title, id: 'nav-dropdown' },
                this.state.modules[4].apps.map(function (item, index) {
                  return _react2.default.createElement(
                    ReactBootstrap.MenuItem,
                    { eventKey: '4.' + (index + 1) },
                    'App ',
                    item.id,
                    ' - ',
                    item.appName
                  );
                })
              ),
              _react2.default.createElement(
                ReactBootstrap.NavDropdown,
                { eventKey: '5', title: this.state.modules[5].title, id: 'nav-dropdown' },
                this.state.modules[5].apps.map(function (item, index) {
                  return _react2.default.createElement(
                    ReactBootstrap.MenuItem,
                    { eventKey: '5.' + (index + 1) },
                    'App ',
                    item.id,
                    ' - ',
                    item.appName
                  );
                })
              )
            ),
            this.state.modules[0].apps.map(function (item, index) {
              return _react2.default.createElement(
                'div',
                null,
                selected === '0.' + item.id && _react2.default.createElement(_components.AdminModuleApp, { ModuleApp: item.prop, Module: item.title,
                  AppNumber: item.id, App: item.appName })
              );
            }),
            this.state.modules[1].apps.map(function (item, index) {
              return _react2.default.createElement(
                'div',
                null,
                selected === '1.' + item.id && _react2.default.createElement(_components.AdminModuleApp, { ModuleApp: item.prop, Module: item.title,
                  AppNumber: item.id, App: item.appName })
              );
            }),
            this.state.modules[2].apps.map(function (item, index) {
              return _react2.default.createElement(
                'div',
                null,
                selected === '2.' + item.id && _react2.default.createElement(_components.AdminModuleApp, { ModuleApp: item.prop, Module: item.title,
                  AppNumber: item.id, App: item.appName })
              );
            }),
            this.state.modules[3].apps.map(function (item, index) {
              return _react2.default.createElement(
                'div',
                null,
                selected === '3.' + item.id && _react2.default.createElement(_components.AdminModuleApp, { ModuleApp: item.prop, Module: item.title,
                  AppNumber: item.id, App: item.appName })
              );
            }),
            this.state.modules[4].apps.map(function (item, index) {
              return _react2.default.createElement(
                'div',
                null,
                selected === '4.' + item.id && _react2.default.createElement(_components.AdminModuleApp, { ModuleApp: item.prop, Module: item.title,
                  AppNumber: item.id, App: item.appName })
              );
            }),
            this.state.modules[5].apps.map(function (item, index) {
              return _react2.default.createElement(
                'div',
                null,
                selected === '5.' + item.id && _react2.default.createElement(_components.AdminModuleApp, { ModuleApp: item.prop, Module: item.title,
                  AppNumber: item.id, App: item.appName })
              );
            })
          )
        )
      );
    }
  }]);
  return AdminModules;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  moduleApp: _propTypes2.default.object
}, _temp2)) || _class);
/* eslint-enable */

exports.default = AdminModules;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Admin/AdminModules.js
// module id = 1146
// module chunks = 0